import { uniqueId } from 'lodash';
import React from 'react';

interface Tab {
  label: string;
  desc?: string;
}

interface TabNavProps {
  tabs: Tab[];
  activeTab: number;
  onTabClick: (index: number) => void;
  tabClassName?: (index: number, isActive: boolean) => string;
  defaultClassName?: string;
  activeClassName?: string;
  navClasses?: string;
}

export const TabNav: React.FC<TabNavProps> = ({
  tabs,
  activeTab,
  onTabClick,
  tabClassName,
  defaultClassName = 'whitespace-nowrap text-xs font-semibold px-2 py-1.5 border-palette-border text-white hover:bg-white hover:text-brand-primary border border-palette-border sm:text-sm sm:px-4 sm:py-2',
  activeClassName = 'bg-brand-primary text-white border border-transparent',
  navClasses = "",
}) => {
  const getClassNames = (index: number) => {
    if (tabClassName) {
      return tabClassName(index, activeTab === index);
    }

    let baseClass = defaultClassName;
    if (index === 0) {
      baseClass += ' rounded-l-md';
    }
    if (index === tabs.length - 1) {
      baseClass += ' rounded-r-md';
    }
    const activeClass = activeTab === index ? activeClassName : '';

    return `${baseClass} ${activeClass}`;
  };

  return (
    <nav aria-label="Tabs" className={`flex justify-center ${navClasses}`}>
      {tabs.map((tab, index) => (
        <div key={uniqueId()} className="flex-1 sm:flex-none">
          <button
            onClick={() => onTabClick(index)}
            className={`w-full ${getClassNames(index)}`}
          >
            <span className="block truncate sm:inline">
              {tab.label}
            </span>
          </button>
        </div>
      ))}
    </nav>
  );
};